import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Infinity as InfinityIcon } from 'lucide-react';
export function LifetimeAccessBonus() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="mt-8 max-w-4xl mx-auto" data-id="element-200">
      <div className="bg-violet-50 rounded-[2.5rem] p-8 md:p-12 border-4 border-violet-200 shadow-xl relative overflow-hidden" data-id="element-201">
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-violet-200/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-202" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-pink-200/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-203" />

        <div className="relative z-10 flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-204">
          <div className="shrink-0 w-48 md:w-56" data-id="element-205">
            <img src="https://cdn.magicpatterns.com/uploads/q95pnAgWMR4B9QZwBL1Zcx/Diseno_sin_titulo.png" alt="Acceso Vitalicio" className="w-full h-auto drop-shadow-lg" data-id="element-206" />
          </div>

          <div className="flex-1 text-center md:text-left" data-id="element-207">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-violet-600 text-white text-[10px] font-black uppercase tracking-[0.2em] mb-6" data-id="element-208">
              <Sparkles size={12} data-id="element-209" />
              <span data-id="element-210">BONO EXTRA EXCLUSIVO</span>
            </div>

            <h3 className="text-3xl md:text-5xl font-black text-violet-950 uppercase italic mb-4 font-[Poppins]" data-id="element-211">
              Acceso <span className="text-violet-600" data-id="element-212">Vitalicio</span>
            </h3>

            <p className="text-violet-900/80 text-lg md:text-xl leading-relaxed mb-6 font-medium" data-id="element-213">
              Olvidate de las mensualidades. Con un solo pago tenés acceso de
              por vida a todo el material y a las futuras actualizaciones sin
              pagar un centavo más.
            </p>

            <div className="flex flex-wrap items-center justify-center md:justify-start gap-4" data-id="element-214">
              <div className="flex items-center gap-2 text-violet-600 font-black uppercase tracking-widest text-sm" data-id="element-215">
                <InfinityIcon size={20} data-id="element-216" />
                <span data-id="element-217">INCLUIDO GRATIS</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>;
}